import { useQuery } from '@tanstack/react-query'

import { getAgreementRequests } from '@src/api'
import { DefaultApiGetAgreementRequestsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { canWriteTermsAgreement } from '@src/utils'

export const useFetchAgreementRequests = (
  params: DefaultApiGetAgreementRequestsRequest
) => {
  const { axiosInstance } = useAxios()

  const { data, isError, isLoading } = useQuery({
    enabled:
      canWriteTermsAgreement() &&
      !!params.organizationId &&
      !!params.waitingForAgreement,
    queryFn: () => getAgreementRequests(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_AGREEMENT_REQUESTS,
      params.organizationId,
      params.waitingForAgreement,
    ],
  })

  return { data, isError, isLoading }
}
